import { ILessonUIState } from 'app/models/ui/call/lesson/constants';

export const CALL_PREFIX = 'call';

export const CALL_SIDEBAR_WIDTH = 320;

export enum CallTab {
  Content = 'content',
  Chat = 'chat',
  Notes = 'notes',
  BotDebug = 'botDebug',
}

export enum CallBar {
  None = 'none',
  Top = 'top',
  Side = 'side',
}

export enum CallVideoPlacement {
  None = 'none',
  InContent = 'inContent',
  InSidebar = 'inSidebar',
  Sticky = 'sticky',
}

export const CALL_BAR_NONE = CallBar.None;
// sidebar next to content
export const CALL_BAR_SIDE = CallBar.Side;
// Mobile
export const CALL_BAR_TOP  = CallBar.Top;

// tabs
export const CALL_TAB_CONTENT = CallTab.Content;
export const CALL_TAB_CHAT    = CallTab.Chat;
export const CALL_TAB_NOTES   = CallTab.Notes;
export const CALL_TAB_BOT_DEBUG = CallTab.BotDebug;

export interface ICallBreakpoint {
  tab: CallTab;
  bar: CallBar;
  videoEnabled: boolean;
  videoPlacement: CallVideoPlacement;
  bigVideo: boolean;
  pushContentDown: boolean;
  hasPeers: boolean;
  lessonUIState: ILessonUIState;
}

// actions
export const SET_TAB              = `${CALL_PREFIX}/setTab`;
export const SET_NAVIGATION_ERROR = `${CALL_PREFIX}/setNavigationError`;
export const SET_IN_CONTENT_SIDEBAR_PRESENT =
  `${CALL_PREFIX}/setInContentSidebarPresent`;
export const INC_IN_CONTENT_VIDEOS_PRESENT = `${CALL_PREFIX}/increaseInContentVideosPresent`;
export const DEC_IN_CONTENT_VIDEOS_PRESENT = `${CALL_PREFIX}/decreaseInContentVideosPresent`;
export const INC_IN_CONTENT_VIDEOS_VISIBLE = `${CALL_PREFIX}/increaseInContentVideosVisible`;
export const DEC_IN_CONTENT_VIDEOS_VISIBLE = `${CALL_PREFIX}/decreaseInContentVideosVisible`;

// The following constants are not actually used to style the elements they correspond to, but instead are used
// as a simple way to help determine whether the user has enough height to use the sidebar view and still see
// a reasonable amount of the chat. This is a naive alternative to trying to measure the available chat space.
const CALL_TAB_HEIGHT = 40;
const INPUT_ROW_HEIGHT = 46;
const SIDEBAR_VIDEO_HEIGHT = 180;
const SIDEBAR_TIMER_HEIGHT = 62;
const SIDEBAR_MARKET_INFO_HEIGHT = 40;
const CONTENT_DROPDOWN_HEIGHT = 54;
const STUDENT_LINK_INFO_HEIGHT = 40;

// Assumes the 'worst case' or most used up space, which is the teacher view in a lesson booking
const CALL_SIDEBAR_PERMANENT_ELEMENTS = [
  CALL_TAB_HEIGHT,
  INPUT_ROW_HEIGHT,
  SIDEBAR_VIDEO_HEIGHT,
  SIDEBAR_TIMER_HEIGHT,
  SIDEBAR_MARKET_INFO_HEIGHT,
  CONTENT_DROPDOWN_HEIGHT,
  STUDENT_LINK_INFO_HEIGHT,
];

export const CALL_SIDEBAR_PERMANENT_ELEMENTS_HEIGHT = CALL_SIDEBAR_PERMANENT_ELEMENTS.reduce((
    total: number, num: number,
) => total + num, 0);

/*
* The percent limit for how much the permitted size of the scaled selfie
* relative to what the size of the selfie would be in the grid. Used to determine when
* the selfie becomes part of the call's video grid.
*/
export const SELFIE_OVERLAP_THRESHOLD = 0.17;
